import React from 'react';
import { ReactComponent as SvgWeightLoss } from "../../assets/lessWeight.svg";
import { ReactComponent as SvgMuscleGain } from "../../assets/muscul.svg";
import { ReactComponent as SvgBodyRecomp } from "../../assets/BodyRecomp.svg";
import { ReactComponent as SvgUndecided } from "../../assets/idk.svg";
import { ReactComponent as Ico1 } from "../../assets/toprof/ico1.svg";
import { ReactComponent as Ico2 } from "../../assets/toprof/ico4.svg";
import { ReactComponent as Ico3 } from "../../assets/toprof/ico3.svg";
import { ReactComponent as Ico4 } from "../../assets/toprof/ico2.svg";

const SummaryPage = ({ userData, onSubmit, currentStep, totalSteps }) => {
    const getGoalIcon = (goal) => {
        const goalIcons = {
            "Похудение": <SvgWeightLoss />,
            "Сбросить лишние килограммы": <SvgWeightLoss />,
            "Набор мышечной массы": <SvgMuscleGain />,
            "Рекомпозиция тела": <SvgBodyRecomp />,
            "Не определился": <SvgUndecided />,
            "Не определился(лась) с ответом": <SvgUndecided />,
        };

        return goalIcons[goal] || null;
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Не указано';
        const date = new Date(dateString);
        return date.toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        });
    };

    return (
        <div className="onboarding-page">
            <div className="onboarding-header">
                <h2>Завершение регистрации</h2>
                <p>Проверьте введённые данные и подтвердите регистрацию</p>
            </div>

            <div className="onboarding-content summary-content">
                <div className="summary-field-group">
                    <div className="summary-field-label">Имя</div>
                    <div className="summary-field-container">
                        <div className="summary-field-value">
                            {userData.name || 'Не указано'}
                        </div>
                    </div>
                </div>

                <div className="summary-field-group">
                    <div className="summary-field-label">Дата рождения</div>
                    <div className="summary-field-container">
                        <div className="summary-field-value">
                            {formatDate(userData.birthDate)}
                        </div>
                    </div>
                </div>

                <div className="summary-field-group">
                    <div className="summary-field-label">Пол</div>
                    <div className="summary-field-container">
                        <div className="summary-field-value">
                            {userData.gender || 'Не указано'}
                        </div>
                    </div>
                </div>

                <div className="summary-field-group">
                    <div className="summary-field-label">Род деятельности</div>
                    <div className="summary-field-container">
                        <div className="summary-field-value">
                            {userData.goal1 || 'Не указано'}
                        </div>
                    </div>
                </div>


                <div className="summary-field-group">
                    <div className="summary-field-label">Фитнес цель</div>
                    <div className="summary-field-container goal-field">
                        {userData.goal2 && getGoalIcon(userData.goal2)}
                        <div className="summary-field-value">
                            {userData.goal2 || 'Не указано'}
                        </div>
                    </div>
                </div>

                <div className="summary-section">
                    <h3>ТОЧКА А: СЕЙЧАС</h3>
                    <div className="point-info">
                        <div className="point-row">
                            <div className="point-label">
                                <div className="ico-box">
                                    <Ico1 className="point-icon" />
                                </div>
                                <span>Вес</span>
                            </div>
                            <span className="point-value">{userData.startPoint.weight} кг</span>
                        </div>
                        <div className="point-row">
                            <div className="point-label">
                                <div className="ico-box">
                                    <Ico2 className="point-icon" />
                                </div>
                                <span>Активы</span>
                            </div>
                            <span className="point-value">{userData.startPoint.assets || "Не указано"}</span>
                        </div>
                        <div className="point-row">
                            <div className="point-label">
                                <div className="ico-box">
                                    <Ico3 className="point-icon" />
                                </div>
                                <span>Уровень дохода</span>
                            </div>
                            <span className="point-value">{userData.startPoint.income || "Не указано"}</span>
                        </div>
                        <div className="point-row">
                            <div className="point-label">
                                <div className="ico-box">
                                    <Ico4 className="point-icon" />
                                </div>
                                <span>Состояние</span>
                            </div>
                            <span className="point-value">{userData.startPoint.condition}/10</span>
                        </div>
                    </div>
                </div>

                <div className="summary-section">
                    <h3>ТОЧКА Б: ЦЕЛЬ</h3>
                    <div className="point-info">
                        <div className="point-row">
                            <div className="point-label">
                                <div className="ico-box">
                                    <Ico1 className="point-icon" />
                                </div>
                                <span>Вес</span>
                            </div>
                            <span className="point-value">{userData.targetPoint.weight} кг</span>
                        </div>
                        <div className="point-row">
                            <div className="point-label">
                                <div className="ico-box">
                                    <Ico2 className="point-icon" />
                                </div>
                                <span>Активы</span>
                            </div>
                            <span className="point-value">{userData.targetPoint.assets || "Не указано"}</span>
                        </div>
                        <div className="point-row">
                            <div className="point-label">
                                <div className="ico-box">
                                    <Ico3 className="point-icon" />
                                </div>
                                <span>Уровень дохода</span>
                            </div>
                            <span className="point-value">{userData.targetPoint.income || "Не указано"}</span>
                        </div>
                        <div className="point-row">
                            <div className="point-label">
                                <div className="ico-box">
                                    <Ico4 className="point-icon" />
                                </div>
                                <span>Состояние</span>
                            </div>
                            <span className="point-value">{userData.targetPoint.condition}/10</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="onboarding-footer">
                <div className="progress-dots">
                    {Array.from({ length: totalSteps }, (_, i) => (
                        <div
                            key={i}
                            className={`progress-dot ${i + 1 === currentStep ? 'active' : ''}`}
                        />
                    ))}
                </div>
                <button
                    className="confirm-button"
                    onClick={onSubmit}
                >
                    Подтвердить
                </button>
            </div>
        </div>
    );
};

export default SummaryPage; 